// React Dependencies
import React, { useLayoutEffect } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

// Internal Dependencies
import { IsEmpty } from '../../../common/checks';
import FormRow from './FormRow';

const useStyles = makeStyles(() => ({
  root: {
    flexGrow:     1,
    marginBottom: 10,
  },
}));

const GridList = ({ value }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: value.id });

  const [id, setId] = React.useState('');
  const [link, setLink] = React.useState('');
  const [fileType, setFileType] = React.useState('');

  const classes = useStyles();

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const setData = () => {
    setLink(value.image || value.video);
    setFileType(!IsEmpty(value.image) ? 'image' : 'video');
    setId(value.id);
  };

  useLayoutEffect(() => {
    setData();
  }, []);

  return (
    <div style={style}>
      <div ref={setNodeRef} {...attributes} {...listeners}>
        <div className={classes.root}>
          <FormRow
            id={id}
            link={link}
            fileType={fileType}
          />
        </div>
      </div>
    </div>
  );
};

GridList.propTypes = {
  value: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default GridList;
